"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWixDomain = exports.composeHeaders = exports.requestIdOrEmptyString = void 0;
const tslib_1 = require("tslib");
const headers_1 = require("@wix/headers");
const utils_1 = require("./utils");
const whitelist_json_1 = tslib_1.__importDefault(require("./whitelist.json"));
function requestIdOrEmptyString(response) {
    var _a;
    return ((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a['x-wix-request-id']) || '';
}
exports.requestIdOrEmptyString = requestIdOrEmptyString;
const composeHeaders = ({ url, disableWixHeaders, wixHeadersOpts, }) => {
    const shouldAssignWixHeaders = !disableWixHeaders && isWixDomain(url);
    return shouldAssignWixHeaders ? (0, headers_1.createHeaders)(wixHeadersOpts) : {};
};
exports.composeHeaders = composeHeaders;
function isWixDomain(url) {
    const isRelative = !(0, utils_1.isAbsoluteUrl)(url);
    if (isRelative) {
        return true;
    }
    const host = `.${(0, utils_1.extractHost)(url)}`;
    const isWhitelisted = whitelist_json_1.default.find((wixHost) => host.endsWith(`.${wixHost}`));
    return !!isWhitelisted;
}
exports.isWixDomain = isWixDomain;
//# sourceMappingURL=headers.js.map